/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, ChangeEvent } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddDriver.css";
import { Gender } from "logistic-packages";
import { IDriver } from "../../../../interface/driver/driver.interface";
import { createDriver } from "../../../../services/driver/driverService";

interface ErrorDetails {
  email: string;
  password: string;
  required: string;
  phoneNo: string;
}

interface DriverFormData {
  sName: string;
  sEmail: string;
  aPhoneNo: number;
  eGender: Gender;
  dDob: string | undefined;
  sPresentAddress: string;
  sTransportCoordinatorNo: string;
}

export const AddDriver = (props: any) => {
  const [error, setError] = useState<ErrorDetails>({
    email: "",
    password: "",
    required: "",
    phoneNo: "",
  });
  const [details, setDetails] = useState<DriverFormData>({
    sName: "",
    sEmail: "",
    aPhoneNo: 0,
    eGender: Gender.MALE,
    dDob: undefined,
    sPresentAddress: "",
    sTransportCoordinatorNo: "",
  });

  const navigate = useNavigate();
  const [isFormEdited, setIsFormEdited] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id: empId } = useParams<{ id: string }>();
  const currentDate = new Date().toISOString().split("T")[0];

  function checkEmail() {
    if (!/^[\w-]+@([\w-]+\.)+[\w-]{2,4}$/.test(details.sEmail || "")) {
      setError({ ...error, email: "Invalid email" });
    } else {
      setError({ ...error, email: "" });
    }
  }

  const inputhandler = async (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
  ) => {
    if (e.target.name === "aPhoneNo") {
      if (e.target.value.length > 10) {
        return; // Exit the function without updating state or performing actions
      }
    }
    setDetails(
      (details) => ({ ...details, [e.target.name]: e.target.value })
    );
    setIsFormEdited(true);
  };

  function isDataNotFilled() {
    return !isFormEdited || !(details.sName && details.aPhoneNo);
  }

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setIsSubmitting(true);
    const userData: Partial<IDriver> = {
      sName: details.sName,
      sEmail: details.sEmail,
      aPhoneNo: details.aPhoneNo,
      eGender: details.eGender,
      dDob: details.dDob ? new Date(details.dDob) : undefined,
      sPresentAddress: details.sPresentAddress,
      sTransportCoordinatorNo: details.sTransportCoordinatorNo,
    };
    await createDriver(userData)
      .then((res) => {
        toast.success("Driver Added Successfully", {
          position: "top-center",
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/users/drivers");
        }, 3000);
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response.data.message, {
          position: "top-center",
          theme: "colored",
        });
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <div className="mx-2">
        <div className="user-content-header py-4">
          <ToastContainer />
          <Row className="mb-2">
            <Col sm="6">
              <h1 className="m-0 text-dark">Driver</h1>
            </Col>

            <Col sm="6">
              <ol className="breadcrumb float-sm-right justify-content-end">
                <li className="breadcrumb-item">
                  <Link to="dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/users/drivers">Drivers</Link>
                </li>
                <li className="breadcrumb-item active">
                  {empId ? "Edit" : "Create"}
                </li>
              </ol>
            </Col>
          </Row>
        </div>
        <Container fluid className="main-container bg-white pb-4">
          <Row className="title-row">
            <p>Add Driver</p>
          </Row>

          <Row className="form-group">
            <Col sm={12} md={6} className="form-fields op">
              <p>Name</p>
              <input
                value={details.sName ? details.sName : ""}
                name="sName"
                required
                onChange={(e) => inputhandler(e)}
                placeholder="Enter Name"
                className="employee-input-field"
                type="text"
              />
              <span className="danger-warning">{error.required}</span>
            </Col>
            <Col sm={12} md={6} className="form-fields op">
              <p>Contact No</p>

              <input
                name="aPhoneNo"
                value={details.aPhoneNo ? details.aPhoneNo : ""}
                required
                onChange={(e) => inputhandler(e)}
                placeholder="Enter Phone"
                className="employee-input-field"
                type="number"
                onKeyDown={(e) => {
                  const allowedChars = "0123456789";
                  if (!allowedChars.includes(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              <span className="danger-warning">{error.phoneNo}</span>
            </Col>
          </Row>
          <Row className="form-group">
            <Col sm={12} md={6} className="form-fields op">
              <p>Transport Coordinator No</p>

              <input
                name="sTransportCoordinatorNo"
                value={details.sTransportCoordinatorNo ? details.sTransportCoordinatorNo : ""}
                onChange={(e) => inputhandler(e)}
                placeholder="Enter Transport Coordinator No"
                className="employee-input-field"
                type="text"
              />
            </Col>
            <Col sm={12} md={6} className="form-fields op">
              <p>Email</p>

              <input
                name="sEmail"
                value={details.sEmail ? details.sEmail : ""}
                required
                onBlur={() => checkEmail()}
                onChange={(e) => inputhandler(e)}
                placeholder="Enter Email"
                className="employee-input-field"
                type="email"
              />
              <span className="danger-warning">{error.email}</span>
            </Col>
            <Col sm={12} md={6} className="form-fields op">
              <p>Gender</p>

              <select
                name="eGender"
                required
                value={details.eGender ? details.eGender : ""}
                onChange={(e) => inputhandler(e)}
                className="employee-input-field"
              >
                <option value={""}>Select any option</option>
                <option value={"MALE"}>MALE</option>
                <option value={"FEMALE"}>FEMALE</option>
                <option value={"OTHERS"}>OTHERS</option>
              </select>
            </Col>
          </Row>
          <Row className="form-group justify-content-center">
            <Col sm={12} md={6} className="form-fields op">
              <p>Date of Birth</p>

              <input
                name="dDob"
                // value={
                //   d.dDob ? details.dDob.toString().substr(0, 10) : ""
                // }
                required
                onChange={(e) => inputhandler(e)}
                placeholder="Enter Date of Birth"
                className="employee-input-field"
                type="date"
                max={currentDate}
              />
            </Col>
          </Row>

          <Row className="form-group">
            <Col sm={12} className="form-fields op">
              <p>Present Address</p>

              <textarea
                name="sPresentAddress"
                value={details.sPresentAddress ? details.sPresentAddress : ""}
                required
                onChange={(e) => inputhandler(e)}
                className="employee-page-textarea"
                // name='page_meta_desc'
                cols={50}
                rows={5}
              ></textarea>
            </Col>
          </Row>
        </Container>
        <div className="card-footer text-center mb-3">
          <button
            className="btn ripple btn-primary btnDataSave"
            name="btnDataSave"
            disabled={isDataNotFilled() || isSubmitting}
            onClick={handleSubmit}
          >
            {" "}
            {empId ? "Update Driver" : "Add Driver"}{" "}
          </button>
        </div>
      </div>
    </>
  );
};
